import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { LieuxProvider } from './hooks/useLieux';
import { ToastProvider, SkeletonPage } from './components/ui';
import AppNav from './components/AppNav';
import AuthPage from './pages/AuthPage';
import Accueil from './pages/Accueil';
import MesLieux from './pages/MesLieux';
import './styles/global.css';

// Pages chargées à la demande : Leaflet, QR Code et l'admin ne pèsent pas au démarrage
const LieuForm = lazy(() => import('./pages/LieuForm'));
const CarteDakar = lazy(() => import('./pages/CarteDakar'));
const Profil = lazy(() => import('./pages/Profil'));
const SuperAdmin = lazy(() => import('./pages/SuperAdmin'));
const PublicAdresse = lazy(() => import('./pages/PublicAdresse'));
const PolitiqueConfidentialite = lazy(() => import('./pages/PolitiqueConfidentialite'));
const SIG = lazy(() => import('./pages/SIG'));

function Politique() {
  const navigate = useNavigate();
  return <PolitiqueConfidentialite onClose={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))} />;
}

function Demarrage() {
  return (
    <div className="demarrage" aria-busy="true">
      <span className="logo-marque logo-marque-grand" />
    </div>
  );
}

function AppInner() {
  const { user, loading } = useAuth();

  if (loading) return <Demarrage />;
  if (!user) return <AuthPage />;

  return (
    <LieuxProvider>
      <div className="app">
        <AppNav />
        <main className="app-contenu">
          <Suspense fallback={<SkeletonPage />}>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Accueil />} />
              <Route path="/lieux" element={<MesLieux key="tous" mode="tous" />} />
              <Route path="/recherche" element={<MesLieux key="recherche" mode="recherche" />} />
              <Route path="/favoris" element={<MesLieux key="favoris" mode="favoris" />} />
              <Route path="/lieux/nouveau" element={<LieuForm key="nouveau" />} />
              <Route path="/lieux/:id/modifier" element={<LieuForm key="modifier" />} />
              <Route path="/carte" element={<CarteDakar />} />
              <Route path="/profil" element={<Profil />} />
              <Route path="/superadmin" element={<SuperAdmin />} />
              <Route path="/sig" element={<SIG />} />
              {/* Anciennes adresses de pages, conservées pour les favoris du navigateur */}
              <Route path="/mes-adresses" element={<Navigate to="/lieux" replace />} />
              <Route path="/nouvelle-adresse" element={<Navigate to="/lieux/nouveau" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Suspense>
        </main>
      </div>
    </LieuxProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Suspense fallback={<Demarrage />}>
            <Routes>
              <Route path="/adresse/:code" element={<PublicAdresse />} />
              <Route path="/confidentialite" element={<Politique />} />
              <Route path="/auth/callback" element={<AppInner />} />
              <Route path="/*" element={<AppInner />} />
            </Routes>
          </Suspense>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
